import i18n from 'i18next';

import type { UserLanguage } from '~/api/user/types';
import type { routes } from '~/providers/RouterProvider/router.routes';
import type { Params } from '~/providers/RouterProvider/router.types';

import { productsQueryOptions } from '~/api/products';
import { queryClient } from '~/providers/QueryClientProvider/queryClient';

export const loader = async ({ params }: { params: Params<typeof routes.editProduct> }) => {
  const products = await queryClient.query({ ...productsQueryOptions, staleTime: 'static' });
  const product = products.find((product) => product.id === +params.productId) ?? null;

  return {
    product,
    locale: i18n.language as UserLanguage,
  };
};
